import { assetApi as api } from './assetApi';
export const addTagTypes = ['Assets'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getAssets: build.query<GetAssetsApiResponse, GetAssetsApiArg>({
        query: queryArg => ({
          url: `/assets`,
          params: {
            search: queryArg.search,
            things: queryArg.things,
            sharedWith: queryArg.sharedWith,
            interactions: queryArg.interactions,
            favorites: queryArg.favorites,
            location: queryArg.location,
            folderId: queryArg.folderId,
            people: queryArg.people,
            mediaType: queryArg.mediaType,
            date: queryArg.date,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type']
          }
        })
        // providesTags: ['Assets']
      }),
      assetSearch: build.mutation<AssetSearchApiResponse, AssetSearchApiArg>({
        query: queryArg => ({
          url: `/assetSearch`,
          method: 'POST',
          body: queryArg.assetSearch
        })
        // invalidatesTags: ['Assets']
      }),
      getAssetsById: build.query<GetAssetsByIdApiResponse, GetAssetsByIdApiArg>(
        {
          query: queryArg => ({ url: `/assets/${queryArg.id}` }),
          providesTags: ['Assets']
        }
      ),
      updateAssets: build.mutation<UpdateAssetsApiResponse, UpdateAssetsApiArg>(
        {
          query: queryArg => ({
            url: `/assets/${queryArg.id}`,
            method: 'PUT',
            body: queryArg.assetsCreateObject
          }),
          invalidatesTags: ['Assets']
        }
      ),
      deleteAssets: build.mutation<DeleteAssetsApiResponse, DeleteAssetsApiArg>(
        {
          query: queryArg => ({
            url: `/assets/${queryArg.id}`,
            method: 'DELETE',
            params: { delete: queryArg['delete'] }
          }),
          invalidatesTags: ['Assets']
        }
      ),
      bulkDeleteAssets: build.mutation<
        BulkDeleteAssetsApiResponse,
        BulkDeleteAssetsApiArg
      >({
        query: queryArg => ({
          url: `/assets/bulk-delete`,
          method: 'POST',
          body: queryArg.body,
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Assets']
      }),
      getAssetLocations: build.query<
        GetAssetLocationsApiResponse,
        GetAssetLocationsApiArg
      >({
        query: queryArg => ({
          url: `/locations`,
          params: {
            location: queryArg.location,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type']
          }
        })
        // providesTags: ['Assets']
      }),
      getAssetThings: build.query<
        GetAssetThingsApiResponse,
        GetAssetThingsApiArg
      >({
        query: queryArg => ({
          url: `/things`,
          params: {
            location: queryArg.location,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type']
          }
        })
        // providesTags: ['Assets']
      }),
      getAssetPeople: build.query<
        GetAssetPeopleApiResponse,
        GetAssetPeopleApiArg
      >({
        query: queryArg => ({
          url: `/people`,
          params: {
            location: queryArg.location,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type']
          }
        })
        // providesTags: ['Assets']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetAssetsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Assets;
  message?: string;
};
export type GetAssetsApiArg = {
  /** Search text */
  search?: string;
  /** Search text */
  things?: string;
  /** Search text */
  sharedWith?: string;
  /** Search text */
  interactions?: string;
  /** Search text */
  favorites?: string;
  /** Search text */
  location?: string;
  /** Search text */
  folderId?: string;
  /** Search text */
  people?: string;
  /** Search text */
  mediaType?: string;
  /** Search text */
  date?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;
};
export type AssetSearchApiResponse =
  /** status 201 Assets has been created successfully. */ {
    ok?: boolean;
    data?: Assets;
    message?: string;
  };
export type AssetSearchApiArg = {
  /** Assets that needs to be added to the application */
  assetSearch: AssetSearch;
};
export type GetAssetsByIdApiResponse = /** status 200 Assets details found. */ {
  ok?: boolean;
  data?: Asset;
  message?: string;
};
export type GetAssetsByIdApiArg = {
  /** ID of the Assets to retrieve */
  id: string;
};
export type UpdateAssetsApiResponse =
  /** status 200 The Assets's details has been updated successfully */ {
    ok?: boolean;
    data?: Assets;
    message?: string;
  };
export type UpdateAssetsApiArg = {
  /** ID of the Assets to update */
  id: string;
  /** Assets that needs to be added to the application */
  assetsCreateObject: AssetsCreateObject;
};
export type DeleteAssetsApiResponse =
  /** status 200 The Assets's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteAssetsApiArg = {
  /** ID of the Assets to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type BulkDeleteAssetsApiResponse =
  /** status 200 Assets have been deleted successfully */ {
    ok?: boolean;
    data?: {
      success?: boolean;
      deletedCount?: number;
    };
    message?: string;
  };
export type BulkDeleteAssetsApiArg = {
  /** flag to hard delete (true for permanent deletion) */
  delete?: boolean;
  /** Array of asset IDs to delete */
  body: {
    assetIds?: string[];
  };
};
export type GetAssetLocationsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Locations;
  message?: string;
};
export type GetAssetLocationsApiArg = {
  /** Search text */
  location?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;
};
export type GetAssetThingsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Things;
  message?: string;
};
export type GetAssetThingsApiArg = {
  /** Search text */
  location?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;
};
export type GetAssetPeopleApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: People;
  message?: string;
};
export type GetAssetPeopleApiArg = {
  /** Search text */
  location?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;
};
export type Assets = {
  count: number;
  rows: {
    id?: string;
    status?: string;
    subscriberId?: string;
    userId?: string;
    location?: string;
    metadata?: {
      size?: string;
      filters?: string;
    };
    url?: string;
    thumbNailUrl?: string;
    createdAt?: string;
    updatedAt?: string;
    fileName?: any;
    contentType?: any;
    size?: any;
    createdBy?: any;
    assetViewDetail: {
      updatedAt?: string;
    };
  }[];
};
export type AssetSearch = {
  sortBy: string;
  orderBy?: string;
  offset?: string;
  search?: string;
  userId?: string;
  subscriberId?: string;
  favorites?: boolean;
  sharedWith?: string;
  people?: any[];
  things?: any[];
  locations?: any[];
  dates?: any[];
  interactions?: any[];
  mediaType?: any[];
  userFolderId?: string;
};
export type Asset = {
  id?: string;
  fileName?: any;
  thumbNailUrl?: string;
  userId?: string;
  subscriberId?: string;
  contentType?: any;
  url?: string;
  size?: number;
  type?: string;
  status?: string;
  userFolderId?: any;
  createdAt?: string;
  updatedAt?: string;
  location?: string;
  metadata?: any;
  user?: {
    userId?: string;
    fullName?: string;
    email?: string;
    userDetail?: {
      profileImage?: string;
    };
  };
  favorite: {
    id: string;
    status: string;
  };
  assetViewDetails?: {
    id?: string;
    userId?: string;
    assetId?: string;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  faceDetections?: {
    id?: string;
    assetId?: string;
    faceId?: string;
    userId?: string;
    confidence?: number;
    boundingBox?: {
      top?: number;
      left?: number;
      width?: number;
      height?: number;
    };
    faceAttributes?: {
      beard?: {
        value?: boolean;
        confidence?: number;
      };
      smile?: {
        value?: boolean;
        confidence?: number;
      };
      gender?: {
        value?: string;
        confidence?: number;
      };
      ageRange?: {
        low?: number;
        high?: number;
      };
      emotions?: {
        type?: string;
        confidence?: number;
      }[];
      eyeglasses?: {
        value?: boolean;
        confidence?: number;
      };
    };
    isVerified?: boolean;
    taggedBy?: string;
    createdAt?: string;
    updatedAt?: string;
    user?: {
      userId?: string;
      fullName?: string;
      email?: string;
      userDetail?: {
        profileImage?: string;
      };
    };
  }[];
  photoTags?: {
    id?: string;
    assetId?: string;
    tagName?: string;
    confidence?: number;
    tagType?: string;
    boundingBox?: any;
    createdAt?: string;
    updatedAt?: string;
  }[];
};
export type AssetsCreateObject = {
  subscriberId?: string;
  mediaType?: string;
  userId?: string;
  fileSizeBytes?: number;
  imageSize?: {
    width?: number;
    height?: number;
  };
  location?: string;
  metadata?: {
    filters?: string;
    location?: string;
    size?: string;
  };
};
export type Locations = string[];
export type Things = {
  id?: string;
  tagName?: string;
}[];
export type People = {
  count?: number;
  rows?: {
    userId?: string;
    fullName?: string;
    email?: string;
    profileImage?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: any;
    dateOfBirth?: any;
    gender?: any;
    maxConfidence?: number;
    isVerified?: boolean;
    detectionCount?: number;
  }[];
};
export const {
  useGetAssetsQuery,
  useAssetSearchMutation,
  useGetAssetsByIdQuery,
  useUpdateAssetsMutation,
  useDeleteAssetsMutation,
  useBulkDeleteAssetsMutation,
  useGetAssetLocationsQuery,
  useGetAssetThingsQuery,
  useGetAssetPeopleQuery
} = injectedRtkApi;
